module.exports = __webpack_public_path__ + "assets_1789460829583/img/logo_v1.098beea9.png";